
<template>
    <ListDialog ref="CommodityJournalDialog" :title="$parent.formatTitle('商品元帳')"  :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
	      <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="CommodityJournalReportTemplateQuery" tooltip="出力する帳票のテンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【商品元帳】のデータを選択でき、初期値は×で消してから変更が可能です。" />
	      <AtcSegment title="部門" :editor="editor" :value.sync="segment" tooltip="ここで部門を選択をすると、選択した部門だけのデータを出力する事ができます。選択しない場合はすべての部門のデータが出力できます。" />
        <AtcCounterpart title="取引先" :editor="editor" :value.sync="counterpart" :needsCustomer="true" :needsSupplier="true" tooltip="ここで取引先を選択をすると、選択した取引先だけのデータを出力する事ができます。選択しない場合はすべての取引先のデータが出力できます。" />
        <AtcCounterpart title="倉庫" :value.sync="warehouse" :editor="editor" :needsWarehouse="true" tooltip="ここで倉庫を選択をすると、選択した倉庫だけのデータを出力する事ができます。選択しない場合はすべての倉庫のデータが出力できます。" />
        <AtcCommodity title="商品" :editor="editor" :value.sync="commodity" tooltip="ここで商品を選択をすると、選択した商品だけのデータを出力する事ができます。選択しない場合はすべての商品のデータが出力できます。" />
        <AtcCategory title="商品区分" :categoryGroup="categoryGroupCommodity" :value.sync="commodityCategory" tooltip="ここで商品区分を選択をすると、選択した区分だけのデータを出力する事ができます。選択しない場合はすべての区分のデータが出力できます。" />
        <Calendar title="日付(From)" :editor="editor" :value.sync="dateFrom" :deletable="false" :required="true" :autoEntry="true" :dateFlag.sync="dateFromFlag" tooltip="データを帳票に出力をする日付の開始日を指定します。ここで指定した日付以前のデータは出力対象外となります。" />
	      <Calendar title="日付(To)" :editor="editor" :value.sync="dateTo" :deletable="false" :required="true" :autoEntry="true" :dateFlag.sync="dateToFlag"  tooltip="データを帳票に出力をする日付の終了日を指定します。ここで指定した日付以降のデータは出力対象外となります。" />
        <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>                
        </template>
        <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
        <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>               
      </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptCommodityJournal extends Vue {

  // 商品元帳用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public dateFrom: Date = null;
  public dateTo: Date = null;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public warehouse: Common.Counterpart = null;
  public commodity: Common.Commodity = null;
  public commodityCategory: Common.Category = null;
  public categoryGroupCommodity: Common.CategoryGroup = Common.CategoryGroup.Commodity;
  public onExcelExport :boolean = false;
  public dateFromFlag : Common.dateFlags = Common.dateFlags.default;
  public dateToFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.CommodityJournalReportTemplateQuery = new Common.CommodityJournalReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    var today = new Date();
    this.dateFrom = new Date(today.getFullYear(),today.getMonth(),1).getCalendarDate();
    this.dateTo = new Date(today.getFullYear(),today.getMonth() +1,0).getCalendarDate();
    (this.$refs.CommodityJournalDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.CommodityJournalReportQuery = new Common.CommodityJournalReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.dateFrom = this.dateFrom;
    query.dateTo = this.dateTo;
    query.segment = this.segment;
    query.counterpart = this.counterpart;
    query.warehouse = this.warehouse;
    query.commodity = this.commodity;
    query.commodityCategory = this.commodityCategory;
    query.onExcelExport = this.onExcelExport;
    this.$api.download(query);
  }
}
</script>
